import { Component, HostBinding, Input } from '@angular/core';
import { ChipModule } from '@vg-constellation/angular-20/chip';

@Component({
    selector: 'zci-pending-chip',
    templateUrl: './pending-chip.component.html',
    styleUrls: ['./pending-chip.component.scss'],
    imports: [
        ChipModule,
    ],
})
export class PendingChipComponent {
    @HostBinding('class.is-inline') @Input() isInline = false;
}
